const dataLayer = window.dataLayer || [];

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicio de sesion normal (Pagina de Login)
 */
export function inicioDeSession() {
  dataLayer.push({
    event: 'inicio_de_sesion',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicio de sesion desde GolStats 1.0
 */
export function inicioDeSesioDesdeGS1() {
  dataLayer.push({
    event: 'inicio_de_sesion_desde_gs1',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicio de sesion desde GolStats 1.0
 */
export function irAInicio() {
  dataLayer.push({
    event: 'ir_a_inicio',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicio de sesion desde GolStats 1.0
 */
export function finalizarSesion() {
  dataLayer.push({
    event: 'finalizar_sesion',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento de menu para Analizar Equipos
 */
export function menuAnalizarEquipos() {
  dataLayer.push({
    event: 'menu_analizar_equipos',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento de menu para Analizar Jugadores
 */
export function menuAnalizarJugadores() {
  dataLayer.push({
    event: 'menu_analizar_jugadores',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento de menu para Analizar Jugadores
 */
export function menuProximosPartidos() {
  dataLayer.push({
    event: 'menu_proximos_partidos',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento Pagina Principal Analizar Equipos
 */
export function analizarEquipos() {
  dataLayer.push({
    event: 'analizar_equipos',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento Pagina Principal Analizar Jugadores
 */
export function analizarJugadores() {
  dataLayer.push({
    event: 'analizar_jugadores',
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento Pagina Principal Analizar Jugadores
 */
export function proximosPartidos() {
  dataLayer.push({
    event: 'proximos_partidos',
  });
}

/**
 * @author Jordan
 * @description Evento Pagina Principal Analizar Jugadores
 */
export function doBetcaliente(params) {
  dataLayer.push({ event: 'realiza_apuesta_caliente', ...params });
}
